module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    staticClass: "new-pamm-msg"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('pamm_statistics_text')) + "\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "t4b-portal-btn-link button is-primary is-halfwidth",
    attrs: {
      "href": "https://pamm.eurotrader.com",
      "target": "_blank"
    }
  }, [_vm._v("PAMM Clientarea (MT4)")]), _vm._v(" "), _c('a', {
    staticClass: "t4b-portal-btn-link button is-primary is-halfwidth",
    attrs: {
      "href": "https://pamm-mt5.eurotrader.com",
      "target": "_blank"
    }
  }, [_vm._v("PAMM Clientarea (MT5)")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27dade06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pamm/pamm-statistics.vue
// module id = 735
// module chunks = 0